import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { useMappingChartsDataContext } from './hooks/useMappingChartsDataContext';
import { TreeMap } from '../../../Common/Charts/TreeMap';

export const RegistersHoseHoldByHealthUnit = () => {
    const { chartData } = useMappingChartsDataContext();

    return (
        <TreeMap
            title={'Atualização dos Cadastros Domiciliares'}
            subtitles={chartData?.registersHoseHoldByHealthUnit?.map((item) => item.description)}
            values={chartData?.registersHoseHoldByHealthUnit?.map((item) => item.total)}
            colors={defaultColors.slice(0, chartData?.registersHoseHoldByHealthUnit?.length) || []}
        />
    );
};
